export const holidaysSelector = (year) => (state) =>
  state.payoutSettingReducer?.holidays?.[year];

export const holidaysLoadingSelector = (state) =>
  state.payoutSettingReducer?.loading || false;

export const afterHoursSelector = (state) =>
  state.payoutSettingReducer?.afterHours;

export const afterHoursLoadingSelector = (state) =>
  state.payoutSettingReducer?.afterHoursLoading || false;

export const generalSelector = (state) =>
  state.payoutSettingReducer?.general;

export const generalLoadingSelector = (state) =>
  state.payoutSettingReducer?.generalLoading || false;
